import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCheckmark2Small"><Path d="M6.5 13.125L9.8 16.5L17.5 7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCheckmark2Small;
